<table
  class="layout-fixed striped"
  *ngIf="dprStatusTrackerModelReport.columns?.length &&
   dprStatusTrackerModelReport.rows?.length
  "
>
  <tbody>
    <tr class="primary-header">
      <th [colSpan]="dprStatusTrackerModelReport.columnNumber">
        <h3>{{customNames.statusTrackerTabName + ' : ' + dprStatusTrackerModelReport.statusTrackerName }}</h3>
      </th>
    </tr>
    <tr class="secondary-header">
      <th rowspan="2" colspan="2" class="border-right"></th>
      <th [colSpan]="dprStatusTrackerModelReport.columnNumber -2" class="text-center">
        {{ dprStatusTrackerModelReport.columnGroupName}}
      </th>
    </tr>
    <tr class="secondary-header">
      <th *ngFor="let column of dprStatusTrackerModelReport.columns" class="text-center">{{column.name}}</th>
    </tr>
    <tr *ngFor="let row of dprStatusTrackerModelReport.rows">
      <td *ngIf="!!row.rowSpan" [rowSpan]="row.rowSpan" class="text-bold">{{row.rowGroupName}}</td>
      <td class="border-right vertical-align-middle text-bold">{{row.rowName}}</td>
      <td *ngFor="let cell of row.values" class="text-center" [style.background-color]="cell.color">{{cell.value}}</td>
    </tr>
  </tbody>
</table>
